import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ProductsAPI from '../../api/products';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getProducts($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getProduct: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async function getProducts({ commit }) {
    commit(types.SET_PRODUCT_UI_FLAG, { isFetching: true });
    try {
      const response = await ProductsAPI.get();
      commit(types.SET_PRODUCTS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_PRODUCT_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createProduct({ commit }, productObj) {
    commit(types.SET_PRODUCT_UI_FLAG, { isCreating: true });
    try {
      // Garantir que currency seja incluído se não especificado
      const productData = {
        currency: 'BRL',
        ...productObj,
      };
      const response = await ProductsAPI.create(productData);
      commit(types.ADD_PRODUCT, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PRODUCT_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateProduct({ commit }, { id, ...productObj }) {
    commit(types.SET_PRODUCT_UI_FLAG, { isUpdating: true });
    try {
      const response = await ProductsAPI.update(id, productObj);
      commit(types.EDIT_PRODUCT, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PRODUCT_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteProduct({ commit }, id) {
    commit(types.SET_PRODUCT_UI_FLAG, { isDeleting: true });
    try {
      await ProductsAPI.delete(id);
      commit(types.DELETE_PRODUCT, id);
    } catch (error) {
      throw error; // Não envolver em new Error para preservar a estrutura original
    } finally {
      commit(types.SET_PRODUCT_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_PRODUCT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.SET_PRODUCTS]: MutationHelpers.set,
  [types.ADD_PRODUCT]: MutationHelpers.create,
  [types.EDIT_PRODUCT]: MutationHelpers.update,
  [types.DELETE_PRODUCT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
